import { createFileRoute } from '@tanstack/react-router';
import { AdminHomePage } from './AdminHomePage';

export const Route = createFileRoute('/_protected/admin/')({
  component: AdminHomePage,
});
